import styles from './AppFooter.module.css'

function AppFooter() {
  return (
    <div className={styles.appFooter}>
    </div>
  );
}
export default AppFooter;